
export default {
  namespaced: true,
  state: {
    chartTemplates: {
      optionsLineChart: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          dataLabels: { enabled: false },
          chart: {
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: true,
                customIcons: []
              }
            },
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 200
              },
              dynamicAnimation: {
                enabled: true,
                speed: 800
              }
            },
            zoom: { enabled: true }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            }
          },
          stroke: {
            show: true,
            curve: 'smooth',
            lineCap: 'butt',
            colors: ['#2AF2FD', '#ff206e', '#2CB5FC'],
            width: 3
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              colorStops: [
                {
                  offset: 0,
                  color: '#8325FB',
                  opacity: 1
                },
                {
                  offset: 20,
                  color: '#5889FC',
                  opacity: 1
                },
                {
                  offset: 60,
                  color: '#2AF2FD',
                  opacity: 1
                }
              ]
            }
          },
          colors: ['#2AF2FD', '#ff206e', '#2CB5FC'],
          annotations: {
            yaxis: [
              {
                strokeDashArray: 0,
                borderColor: '#FC1474',
                borderWidth: 1,
                label: {
                  borderColor: '#FC1474',
                  borderRadius: 0,
                  borderWidth: 0,
                  style: {
                    color: '#FFF',
                    fontWeight: 600,
                    background: '#FC1474',
                    borderColor: '#FC1474',
                    padding: {
                      top: 5,
                      bottom: 5,
                      left: 7,
                      right: 7
                    }
                  }
                }
              }
            ]
          },
          xaxis: {
            type: 'datetime',
            tickAmount: 8,
            labels: {
              formatter: value => {
                const date = new Date(value)
                return date.toLocaleDateString('en-US', {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                  day: 'numeric',
                  month: 'short'
                })
              }
            },
            axisBorder: {
              show: true,
              color: '#A194AA',
              height: 1,
              width: '100%',
              offsetX: 0,
              offsetY: 0
            },
            axisTicks: {
              show: true,
              borderType: 'solid',
              color: '#A194AA',
              height: 6,
              offsetX: 0,
              offsetY: 0
            }
          },
          yaxis: {
            decimalsInFloat: 2, // Güncellendi. UPDATED
            tickAmount: 5,
            axisBorder: {
              show: true,
              color: '#A194AA',
              offsetX: 0,
              offsetY: 0
            },
            axisTicks: {
              show: true,
              borderType: 'solid',
              color: '#A194AA',
              width: 6,
              offsetX: 0,
              offsetY: 0
            },
            title: {
              style: {
                fontSize: '14px',
                fontWeight: 400,
                color: '#A194AA'
              }
            }
          },
          title: {
            style: {
              fontSize: '14px',
              fontWeight: 400,
              color: '#A194AA'
            }
          },
          legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'left',
            showForSingleSeries: false
          }
        }
      },
      optionsMultiLineChart: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          dataLabels: { enabled: false },
          chart: {
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: true,
                customIcons: []
              }
            },
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 200
              },
              dynamicAnimation: {
                enabled: true,
                speed: 800
              }
            },
            zoom: { enabled: true }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            }
          },
          stroke: {
            show: true,
            curve: 'smooth',
            lineCap: 'butt',
            colors: ['#FC1474', '#FD64AA', '#FED3E7'],
            width: 3
          },
          colors: ['#FC1474', '#FD64AA', '#FED3E7'],
          annotations: {
            yaxis: [
              {
                strokeDashArray: 0,
                borderColor: '#FC1474',
                borderWidth: 1,
                label: {
                  borderColor: '#FC1474',
                  borderRadius: 0,
                  borderWidth: 0,
                  style: {
                    color: '#FFF',
                    fontWeight: 600,
                    background: '#FC1474',
                    borderColor: '#FC1474',
                    padding: {
                      top: 5,
                      bottom: 5,
                      left: 7,
                      right: 7
                    }
                  }
                }
              }
            ]
          },
          xaxis: {
            type: 'datetime',
            tickAmount: 8,
            labels: {
              formatter: value => {
                const date = new Date(value)
                return date.toLocaleDateString('en-US', {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                  day: 'numeric',
                  month: 'short'
                })
              }
            },
            axisBorder: {
              show: true,
              color: '#A194AA',
              height: 1,
              width: '100%',
              offsetX: 0,
              offsetY: 0
            },
            axisTicks: {
              show: true,
              borderType: 'solid',
              color: '#A194AA',
              height: 6,
              offsetX: 0,
              offsetY: 0
            }
          },
          yaxis: {
            decimalsInFloat: 2, // Güncellendi. UPDATED
            tickAmount: 5,
            axisBorder: {
              show: true,
              color: '#A194AA',
              offsetX: 0,
              offsetY: 0
            },
            axisTicks: {
              show: true,
              borderType: 'solid',
              color: '#A194AA',
              width: 6,
              offsetX: 0,
              offsetY: 0
            },
            title: {
              style: {
                fontSize: '14px',
                fontWeight: 400,
                color: '#A194AA'
              }
            }
          },
          title: {
            style: {
              fontSize: '14px',
              fontWeight: 400,
              color: '#A194AA'
            }
          },
          legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'left',
            showForSingleSeries: false
          }
        }
      },
      optionsMultiColorLineChart: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          dataLabels: { enabled: false },
          chart: {
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: true,
                customIcons: []
              }
            },
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 200
              },
              dynamicAnimation: {
                enabled: true,
                speed: 800
              }
            },
            zoom: { enabled: true }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            }
          },
          stroke: {
            show: true,
            curve: 'smooth',
            lineCap: 'butt',
            colors: ['#1877f2', '#ff0000', '#1da1f2', '#010101', '#0a66c2'],
            width: 3
          },
          colors: ['#1877f2', '#ff0000', '#1da1f2', '#010101', '#0a66c2'],
          annotations: {
            yaxis: [
              {
                strokeDashArray: 0,
                borderColor: '#FC1474',
                borderWidth: 1,
                label: {
                  borderColor: '#FC1474',
                  borderRadius: 0,
                  borderWidth: 0,
                  style: {
                    color: '#FFF',
                    fontWeight: 600,
                    background: '#FC1474',
                    borderColor: '#FC1474',
                    padding: {
                      top: 5,
                      bottom: 5,
                      left: 7,
                      right: 7
                    }
                  }
                }
              }
            ]
          },
          xaxis: {
            type: 'datetime',
            tickAmount: 8,
            labels: {
              formatter: value => {
                const date = new Date(value)
                return date.toLocaleDateString('en-US', {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                  day: 'numeric',
                  month: 'short'
                })
              }
            },
            axisBorder: {
              show: true,
              color: '#A194AA',
              height: 1,
              width: '100%',
              offsetX: 0,
              offsetY: 0
            },
            axisTicks: {
              show: true,
              borderType: 'solid',
              color: '#A194AA',
              height: 6,
              offsetX: 0,
              offsetY: 0
            }
          },
          yaxis: {
            decimalsInFloat: 2, // Güncellendi. UPDATED
            tickAmount: 5,
            axisBorder: {
              show: true,
              color: '#A194AA',
              offsetX: 0,
              offsetY: 0
            },
            axisTicks: {
              show: true,
              borderType: 'solid',
              color: '#A194AA',
              width: 6,
              offsetX: 0,
              offsetY: 0
            },
            title: {
              style: {
                fontSize: '14px',
                fontWeight: 400,
                color: '#A194AA'
              }
            }
          },
          title: {
            style: {
              fontSize: '14px',
              fontWeight: 400,
              color: '#A194AA'
            }
          },
          legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'left',
            showForSingleSeries: false
          }
        }
      },
      optionsAreaChart: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            sparkline: {
              enabled: true
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth',
            width: 2
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 0.9,
              opacityFrom: 0.5,
              opacityTo: 0.2,
              stops: [0, 80, 100]
            }
          },
          xaxis: {
            type: 'numeric',
            lines: {
              show: false
            },
            axisBorder: {
              show: false
            },
            labels: { show: false }
          },
          tooltip: {
            x: { show: false }
          },
          theme: {
            monochrome: {
              enabled: true,
              shadeTo: 'light',
              shadeIntensity: 0.65
            }
          }
        }
      },
      optionsScatterChart: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          chart: {
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: true,
                customIcons: []
              }
            },
            background: '',
            zoom: {
              enabled: true,
              type: 'xy'
            }
          },
          annotations: {
            yaxis: [
              {
                borderWidth: 1,
                label: {
                  offsetY: 0,
                  borderWidth: 0,
                  borderRadius: 0,
                  style: {
                    fontSize: '11px'
                  }
                }
              }
            ],
            xaxis: [
              {
                borderWidth: 1,
                label: {
                  offsetY: 20,
                  borderWidth: 0,
                  borderRadius: 0,
                  orientation: 'horizontal',
                  style: {
                    fontSize: '11px'
                  }
                }
              }
            ]
          },
          grid: {
            padding: {
              bottom: 10
            },
            xaxis: {
              lines: {
                show: false
              }
            },
            yaxis: {
              lines: {
                show: false
              }
            }
          },
          colors: ['#7367f0', '#28c76f', '#00cfe8', '#ff9f43', '#ea5455'],
          legend: {
            show: false,
            position: 'bottom',
            horizontalAlign: 'left'
          },
          xaxis: {
            tickAmount: 10
          },
          yaxis: {
            title: {
              align: 'left',
              style: {
                fontSize: '12px',
                color: '#DDBA90'
              }
            }
          },
          markers: {
            size: 12
          }
        }
      },
      optionsDonutChart: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 800
              },
              dynamicAnimation: {
                enabled: true,
                speed: 800
              }
            }
          },
          dataLabels: {
            enabled: false,
            background: {
              enabled: false
            },
            style: {
              fontSize: '14px',
              fontWeight: 'bolder',
              colors: ['#FFF']
            }
          },
          legend: {
            show: false
          },
          colors: ['#FD99C7', '#FC1474']
        }
      },
      optionsPieChart: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 800
              },
              dynamicAnimation: {
                enabled: true,
                speed: 800
              }
            }
          },
          plotOptions: {
            pie: {
              offsetX: 0,
              offsetY: 0,
              customScale: 1,
              dataLabels: {
                offset: 32,
                minAngleToShowLabel: 10
              }
            }
          },
          grid: {
            padding: {
              top: 5,
              right: 0,
              bottom: 0,
              left: 0
            },
          },
          dataLabels: {
            enabled: true,
            background: {
              enabled: false
            },
            style: {
              fontSize: '11px',
              fontWeight: 'bolder',
              colors: ['#FFF']
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'left'
          },
          stroke: {
            width: 4
          },
          colors: ['#FC1474', '#FC4097', '#FD64AA', '#FD99C7', '#FED3E7', '#fde8f2']
        }
      },
      optionsSmallPie: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          chart: {
            toolbar: {
              show: false
            },
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 800
              },
              dynamicAnimation: {
                enabled: true,
                speed: 800
              }
            }
          },
          plotOptions: {
            pie: {
              offsetX: 0,
              offsetY: 0,
              customScale: 1,
              dataLabels: {
                offset: 12,
                minAngleToShowLabel: 10
              }
            }
          },
          grid: {
            padding: {
              top: 5,
              right: 0,
              bottom: 0,
              left: 0
            },
          },
          dataLabels: {
            enabled: true,
            background: {
              enabled: false
            },
            style: {
              fontSize: '11px',
              fontWeight: 'bolder',
              colors: ['#FFF']
            }
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'left'
          },
          stroke: {
            width: 4
          },
          colors: ['#FC1474', '#FC4097', '#FD64AA', '#FD99C7', '#FED3E7', '#fde8f2'],
        }
      },
      optionsSmallBar: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          chart: {
            toolbar: {
              show: false
            }
          },
          tooltip: {
            marker: {
              fillColors: ['#FC1474', '#FC4097', '#FD64AA', '#FD99C7', '#FED3E7']
            }
          },
          colors: ['#FC1474', '#FC4097', '#FD64AA', '#FD99C7', '#FED3E7'],
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: '80%'
            }
          },
          fill: {
            colors: ['#FC1474', '#FC4097', '#FD64AA', '#FD99C7', '#FED3E7'],
            opacity: 0.9,
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 0.5,
              opacityTo: 1,
              stops: [0, 80, 100],
              colorStops: []
            }
          },
          grid: {
            show: false,
            padding: {
              top: 0,
              bottom: 0
            }
          },
          dataLabels: {
            enabled: true
          },
          xaxis: {
            labels: {
              show: false
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false,
              color: '#A194AA',
              offsetX: 0,
              offsetY: 0
            }
          },
          yaxis: {
            axisBorder: {
              show: false,
              color: '#A194AA',
              offsetX: 0,
              offsetY: 0
            }
          }
        }
      },
      optionsColumnChart: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          dataLabels: { enabled: false },
          chart: {
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            },
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: true,
                customIcons: []
              }
            },
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 200
              },
              dynamicAnimation: {
                enabled: true,
                speed: 800
              }
            },
            zoom: { enabled: true }
          },
          fill: {
            colors: ['#FC1474', '#FD64AA'],
            opacity: 0.9,
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'vertical',
              shadeIntensity: 0.5,
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 80, 100]
            }
          },
          plotOptions: {
            bar: {
              backgroundBarColors: ['transparent'],
              horizontal: false,
              barHeight: '20%'
            }
          },
          grid: {
            yaxis: {
              lines: {
                show: false
              }
            }
          },
          yaxis: {
            // opposite: isRtl,
          }
        }
      },
      optionsLineBarChart: {
        chartOptions: {
          noData: {
            text: 'No Data',
            style: {
              color: '#FFFFFF',
            }
          },
          chart: {
            height: 350,
            type: 'line',
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: true,
                customIcons: []
              }
            },
          },
          grid: {
            padding: {
              top: 20,
              right: 0,
              bottom: 10,
              left: 0
            },
          },
          stroke: {
            show: true,
            curve: 'smooth',
            lineCap: 'butt',
            width: [0, 3]
          },
          fill: {
            colors: ['#FC1474', '#f54000'],
            type: 'vertical',
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.9,
              colorStops: [
                {
                  offset: 0,
                  color: '#FC1474',
                  opacity: 1
                },
                {
                  offset: 20,
                  color: '#FC1474',
                  opacity: 1
                },
                {
                  offset: 60,
                  color: '#28E9FD',
                  opacity: 1
                }
              ]
            }
          },
          colors: ['#ff206e', '#28E9FD'],
          dataLabels: {
            enabled: false,
            enabledOnSeries: [1],
            background: {
              enabled: true,
              foreColor: '#07585d',
              padding: 4,
              borderRadius: 2,
              borderWidth: 1,
              borderColor: '#07585d',
              opacity: 0.9,
              dropShadow: {
                enabled: false,
                top: 1,
                left: 1,
                blur: 1,
                color: '#000',
                opacity: 0.45
              }
            },
          },
          legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'left',
            showForSingleSeries: false
          },
          xaxis: {
            type: 'datetime',
            tickAmount: 8,
            labels: {
              formatter: value => {
                const date = new Date(value)
                return date.toLocaleDateString('en-US', {
                  minimumIntegerDigits: 2,
                  useGrouping: false,
                  day: 'numeric',
                  month: 'short'
                })
              }
            },
            axisBorder: {
              show: true,
              color: '#A194AA',
              height: 1,
              width: '100%',
              offsetX: 0,
              offsetY: 0
            },
            axisTicks: {
              show: true,
              borderType: 'solid',
              color: '#A194AA',
              height: 6,
              offsetX: 0,
              offsetY: 0
            }
          },
          yaxis: [{
            title: {
              style: {
                fontSize: '14px',
                fontWeight: 400,
                color: '#A194AA'
              }
            },
          },{
            opposite: true,
            title: {
              style: {
                fontSize: '14px',
                fontWeight: 400,
                color: '#A194AA'
              }
            }
          }]
        },
      }
    }
  },
  getters: {
    getOptsLineChart: state => state.chartTemplates.optionsLineChart.chartOptions,
    getOptsMultiLineChart: state => state.chartTemplates.optionsMultiLineChart.chartOptions,
    getOptsMultiColorLineChart: state => state.chartTemplates.optionsMultiColorLineChart.chartOptions,
    getOptsAreaChart: state => state.chartTemplates.optionsAreaChart.chartOptions,
    getOptsScatterChart: state => state.chartTemplates.optionsScatterChart.chartOptions,
    getOptsPieChart: state => state.chartTemplates.optionsPieChart.chartOptions,
    getOptsSmallPie: state => state.chartTemplates.optionsSmallPie.chartOptions,
    getOptsDonutChart: state => state.chartTemplates.optionsDonutChart.chartOptions,
    getOptsSmallBar: state => state.chartTemplates.optionsSmallBar.chartOptions,
    getOptsColumnChart: state => state.chartTemplates.optionsColumnChart.chartOptions,
    getOptsLineBarChart: state => state.chartTemplates.optionsLineBarChart.chartOptions
  }
}
